import { FC, Fragment } from 'react';

import { getAuctionEditUrl } from 'utils/auction';
import { isAccountStatusReadOnly } from 'utils/clickme';
import { NON_BREAKING_SPACE } from 'utils/constants/common';
import { CampaignPauseReason } from 'utils/constants/dashboard';

import { Link } from '@hh.ru/redux-spa-middleware';

import DropDownClick, { DownPlacement } from 'bloko/blocks/drop/Down/Click';
import BlokoLink from 'bloko/blocks/link';

import useTrls from 'hooks/translation/useTrls';

import BlockedReason from 'components/BlockedReason';

import { FrontendStatusType } from 'store/models/dashboard';
import { useSelector } from 'store/utils';

interface StatusPausedProps {
    frontendStatus: FrontendStatusType;
    isBanner: boolean;
    campaignId: number;
    userBalance: number;
    realBalance: number;
    isAuction?: boolean;
    vacancyId?: number | null;
}

const StatusPaused: FC<StatusPausedProps> = ({
    campaignId,
    frontendStatus,
    userBalance,
    realBalance,
    isBanner,
    isAuction,
    vacancyId,
}) => {
    const currentAccountStatus = useSelector((state) => state.user.user?.currentAccount.status);
    const trl = useTrls();

    if (isAccountStatusReadOnly(currentAccountStatus)) {
        return null;
    }

    if (userBalance === 0) {
        return (
            <Fragment>
                {!isBanner
                    ? trl('campaign.actions.status.pausedOrActive.outBalance.status')
                    : trl('campaign.actions.status.pausedOrActive.outBalance.banner.status')}
                {NON_BREAKING_SPACE}
                <BlokoLink href="/new/invoice/create">
                    {trl('campaign.actions.status.pausedOrActive.outBalance.link')}
                </BlokoLink>
            </Fragment>
        );
    }

    if (realBalance === 0) {
        return (
            <Fragment>
                {!isBanner
                    ? trl('campaign.actions.status.pausedOrActive.outRealBalance')
                    : trl('campaign.actions.status.pausedOrActive.outRealBalance.banner')}
                <br />(
                <DropDownClick
                    showCloseButton
                    render={() => (
                        <BlockedReason
                            action={`/campaign/${campaignId}#step_3`}
                            title={trl('campaign.actions.status.pausedOrActive.blockedReason.title')}
                            anchor={trl('campaign.actions.status.pausedOrActive.blockedReason.anchor')}
                            text={trl('campaign.actions.status.pausedOrActive.blockedReason.text')}
                        />
                    )}
                    placement={DownPlacement.BottomEnd}
                >
                    <BlokoLink>{trl('campaign.actions.status.findReason.link')}</BlokoLink>
                </DropDownClick>
                )<br />
            </Fragment>
        );
    }

    let message = trl('campaign.actions.status.paused.budget');
    if (frontendStatus === CampaignPauseReason.DailyBudgetExceedStatus) {
        message = trl('campaign.actions.status.paused.dailyBudget');
    }

    return (
        <div data-qa="ad-block__campaign-state">
            {!isBanner
                ? trl('campaign.actions.status.paused.part1')
                : trl('campaign.actions.status.paused.part1.banner')}
            {NON_BREAKING_SPACE}
            <BlokoLink
                Element={Link}
                to={isAuction && vacancyId ? getAuctionEditUrl(vacancyId) : `/new/campaign/${campaignId}?step=1`}
            >
                {message}
            </BlokoLink>
            {NON_BREAKING_SPACE}
            {trl('campaign.actions.status.paused.part2')}
        </div>
    );
};

export default StatusPaused;
